export default __webpack_public_path__ + "static/media/F1.db089b0e.mp3";